import React from 'react';
import { motion } from 'framer-motion';
import ParallaxHero from '../../components/ui/ParallaxHero';
import Section from '../../components/ui/Section';

const ProductCard = ({ title, type, price, image, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.7, delay }}
    whileHover={{ y: -6 }}
    className="group cursor-pointer overflow-hidden flex flex-col h-full bg-white/5 backdrop-blur-md border border-white/10 rounded-sm"
    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 0 30px rgba(212,175,55,0.1), 0 0 60px rgba(212,175,55,0.04)'; e.currentTarget.style.borderColor = 'rgba(212,175,55,0.3)'; }}
    onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; }}
    style={{ transition: 'box-shadow 0.7s ease, border-color 0.7s ease' }}
  >
    <div className="relative h-64 overflow-hidden">
      <img src={image} alt={title} className="w-full h-full object-cover object-top opacity-65 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
      <div className="absolute top-4 right-4 bg-dark/80 backdrop-blur-sm px-3 py-1 text-xs uppercase tracking-widest text-gold border border-gold/20">
        {type}
      </div>
    </div>
    <div className="p-6 flex flex-col flex-grow">
      <h3 className="text-xl font-serif mb-2 text-cream group-hover:text-gold transition-colors duration-500">{title}</h3>
      <div className="mt-auto pt-6 flex items-center justify-between">
        <span className="text-xl font-light text-cream">{price} €</span>
        <button className="text-sm uppercase tracking-widest border-b border-gold text-gold pb-1 hover:text-cream hover:border-cream transition-colors duration-300">
          Details
        </button>
      </div>
    </div>
  </motion.div>
);

const Shop = () => (
  <div>
    <ParallaxHero
      image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/5e962f4e81ed25550f0f4cdc2d6861b4.png"
      tag="Online Boutique"
      title="Deine Transformation beginnt hier."
      titleHighlight="hier."
      subtitle="Schnelle Lösungen & energetische Deep-Dives für Deinen Alltag."
    />
    <Section>
      <div className="mb-12 flex justify-between items-end border-b border-white/10 pb-4">
        <h2 className="text-2xl font-serif">Schnelle Lösungen</h2>
        <span className="text-cream/50 text-sm uppercase tracking-widest">Minikurse & E-Books</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <ProductCard title="Inneres Kind Healing" type="Minikurs" price="99" delay={0.1}
          image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/276ace7e98fc392a3a18ddcb52406911.png" />
        <ProductCard title="Manifestations-Geheimnisse" type="E-Book" price="29" delay={0.2}
          image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/0a8dbd1ab6196d088ee699a1d0e6492e.png" />
        <ProductCard title="Souveränität im Alltag" type="Meditation" price="49" delay={0.3}
          image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/5e962f4e81ed25550f0f4cdc2d6861b4.png" />
      </div>

      <div className="mb-12 mt-28 flex justify-between items-end border-b border-white/10 pb-4">
        <h2 className="text-2xl font-serif">Tiefen-Coaching Bundles</h2>
        <span className="text-cream/50 text-sm uppercase tracking-widest">Masterclasses</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <ProductCard title="The Queen Circle – Jahreszugang" type="Membership" price="1.200" delay={0.1}
          image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/5e962f4e81ed25550f0f4cdc2d6861b4.png" />
        <ProductCard title="Business Launch Code" type="Intensivkurs" price="890" delay={0.2}
          image="https://media-manager-c.questera.ai/greta-media/8c84f85263efda659889de32f1f32e795be69e9a2504f254db44deecf03d5d2eaf8d8138b6c4ad97d7d004f4d5618742/images/aW1hZ2UvcG5n/c8e44d59a4e812fc499ebd3f1cc275f0.png" />
      </div>
    </Section>
  </div>
);

export default Shop;